// Текст snackbar для ответа дистрибьютора со статусом ИЗМЕНЕНЁН (CHANGED).
// Бэк (OrderSenderService.ApplyFilialResponse) уже проставил на строках заказа флаги
// quantityChanged / priceChanged / discountChanged / workloadGroupChanged / promoGroupChanged
// и старые значения old*; здесь только собираем из них читаемый список.
// Результат вставляется через v-html (Snackbar.vue), поэтому названия экранируются.

const MAX_LINES_DEFAULT = 7;

const decimalFormatter = new Intl.NumberFormat("kk-KZ", {
  style: "decimal",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function formatDecimal(value) {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  return Number.isFinite(number) ? decimalFormatter.format(number) : escapeHtml(value);
}

function formatPlain(value) {
  if (value === null || value === undefined || value === "") return "—";
  return escapeHtml(value);
}

// винительный падеж: изменил 1 позицию, 2–4 позиции, 5+ позиций
function pluralPositions(count) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return "позицию";
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return "позиции";
  return "позиций";
}

function detailName(detail, index) {
  const goods = detail.goods || {};
  const name = (goods.name && goods.name.name) || goods.fullName || detail.distributorGoodsName;
  return name ? escapeHtml(name) : `Позиция №${index + 1}`;
}

export function isDetailChanged(detail) {
  return Boolean(
    detail.quantityChanged ||
      detail.priceChanged ||
      detail.discountChanged ||
      detail.workloadGroupChanged ||
      detail.promoGroupChanged
  );
}

export function describeDetailChanges(detail) {
  const parts = [];
  if (detail.quantityChanged)
    parts.push(`кол-во ${formatPlain(detail.oldQuantity)} → ${formatPlain(detail.quantity)}`);
  if (detail.priceChanged)
    parts.push(`цена ${formatDecimal(detail.oldPrice)} → ${formatDecimal(detail.price)}`);
  if (detail.discountChanged)
    parts.push(`скидка ${formatDecimal(detail.oldDiscount)} → ${formatDecimal(detail.discount)}`);
  if (detail.workloadGroupChanged)
    parts.push(
      `группа нагрузки ${formatPlain(detail.oldWorkloadGroup)} → ${formatPlain(detail.workloadGroup)}`
    );
  if (detail.promoGroupChanged)
    parts.push(`промо-группа ${formatPlain(detail.oldPromoGroup)} → ${formatPlain(detail.promoGroup)}`);
  return parts.join(", ");
}

/**
 * @param {Array} orderDetails строки заказа из ответа /Order/SendAsync
 * @param {number} maxLines сколько позиций перечислять, остальное — «и ещё N»
 * @returns {string} HTML для snackbar; если ни одна строка не помечена — общий текст без списка
 */
export function buildChangedOrderMessage(orderDetails, maxLines = MAX_LINES_DEFAULT) {
  const details = Array.isArray(orderDetails) ? orderDetails : [];
  const changed = details.filter(isDetailChanged);

  if (!changed.length) {
    return "Заказ был изменён поставщиком. Посмотрите детали.";
  }

  const header = `Поставщик изменил ${changed.length} ${pluralPositions(changed.length)} из ${details.length}:`;

  const lines = changed
    .slice(0, maxLines)
    .map((detail) => `<b>${detailName(detail, details.indexOf(detail))}</b>: ${describeDetailChanges(detail)}`);

  const rest = changed.length - lines.length;
  if (rest > 0) {
    lines.push(`…и ещё ${rest} ${pluralPositions(rest)}`);
  }

  return [header, ...lines].join("<br>");
}
